import { Component, EventEmitter, OnInit, Input, Output, SimpleChanges } from '@angular/core';
import { MixpanelService } from '../../services/mixpanel.service';

@Component({
    selector: 'app-export-dialog',
    templateUrl: './export-dialog.component.html',
    styleUrls: ['./export-dialog.component.scss'],
    standalone: false
})
export class ExportDialogComponent {

  @Input() isDownloading: boolean = false;
  @Input() fileName: string = '';
  @Input() mixpanelEventName: string = "";
  @Input() additionalMixpanelProperties: any = {};
  @Input() showSelectFileType: boolean = true;
  @Input() title: string = "Export Options";
  @Input() buttonText: string = "Export";
  @Output() export = new EventEmitter<{fileName: string, fileType: string}>();
  @Output() cancel = new EventEmitter<void>();
  
  fileType = 'xlsx';
  showDownloadedText: boolean = false;

  constructor(
    private _mixpanelService: MixpanelService
  ) { }

  exportFile() {
    this.isDownloading = true;
    this.export.emit({fileName: this.fileName, fileType: this.fileType});

    // Add Mixpanel tracking
    this._mixpanelService.track(`Exported ${this.mixpanelEventName}`, {
      fileName: this.fileName,
      fileType: this.fileType,
      ...this.additionalMixpanelProperties
    });
  }

  onCancel() {
    this.cancel.emit();
  }

}
